import { render } from "./ProjectModelInfoDrawerPanel.vue?vue&type=template&id=09cfdd93&scoped=true"
import script from "./ProjectModelInfoDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProjectModelInfoDrawerPanel.vue?vue&type=script&lang=js"

import "./ProjectModelInfoDrawerPanel.vue?vue&type=style&index=0&id=09cfdd93&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cfdd93"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem,QIcon});
